import { useContext, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import Button from '../../components/Button/Button';
import AlertModal from '../../components/AlertModal/AlertModal';
import { ReactComponent as Eye } from '../../assets/eye.svg';
import { ReactComponent as EyeOff } from '../../assets/eye-off.svg';
import Logo from '../../assets/logo-chatbot.png';
import './ResetPasswordPage.scss';

export default function ResetPasswordPage() {
  const { axiosAuth } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null); // { variant, title, message, onClose }

  const todayDate = new Date();
  const year = todayDate.getFullYear();

  async function handleSubmit(e) {
    e.preventDefault();
    if (loading) return;
    if (!token) {
      setAlert({
        variant: 'danger',
        title: 'Link inválido',
        message: 'O link de recuperação é inválido ou está incompleto.',
        onClose: () => setAlert(null),
      });
      return;
    }
    if (password.length < 8) {
      setAlert({
        variant: 'danger',
        title: 'Validação',
        message: 'A password deve ter pelo menos 8 caracteres.',
        onClose: () => setAlert(null),
      });
      return;
    }
    if (password !== confirm) {
      setAlert({
        variant: 'danger',
        title: 'Validação',
        message: 'As passwords não coincidem.',
        onClose: () => setAlert(null),
      });
      return;
    }

    setLoading(true);
    try {
      await axiosAuth.post('/auth/reset-password', {
        token,
        new_password: password,
      });
      setAlert({
        variant: 'info',
        title: 'Password alterada',
        message: 'A sua password foi alterada com sucesso.',
        onClose: () => navigate('/login', { replace: true }),
      });
    } catch (err) {
      const msg =
        err?.response?.status === 400
          ? 'O link é inválido ou expirou. Peça um novo email de recuperação.'
          : 'Ocorreu um erro. Tente mais tarde.';
      setAlert({
        variant: 'danger',
        title: 'Erro',
        message: msg,
        onClose: () => setAlert(null),
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      {alert && (
        <AlertModal
          variant={alert.variant}
          title={alert.title}
          message={alert.message}
          onClose={alert.onClose}
        />
      )}
      <div className="container">
        <div className="left"></div>
        <div className="right">
          <div className="login-card">
            <img src={Logo} className="logo" alt="Logo HotéisDigitais" />
            <h2 className="reset-title">Definir nova password</h2>
            <form onSubmit={handleSubmit} className="auth-form">
              <div className="row">
                <label className="label">Nova password</label>
                <input
                  className="input"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading}
                  autoComplete="new-password"
                  minLength={8}
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowPassword((p) => !p)}
                >
                  {showPassword ? <EyeOff /> : <Eye />}
                </button>
              </div>
              <div className="row">
                <label className="label">Confirmar password</label>
                <input
                  className="input"
                  type={showPassword ? 'text' : 'password'}
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  required
                  disabled={loading}
                  autoComplete="new-password"
                  minLength={8}
                />
              </div>
              <div className="buttons">
                <Button type="submit" disabled={loading}>
                  Alterar password
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="credits">
        <p>
          <a
            href="https://hoteisdigitais.com/"
            target="_blank"
            rel="noreferrer"
          >
            HoteisDigitais{' '}
          </a>
          @ {year}. Todos os direitos reservados.
        </p>
      </div>
    </div>
  );
}
